import { AdminDTO } from '../../../src_server/entity/dto/AdminDTO';

import { LessonSummaryDTO } from '../../../src_server/entity/dto/LessonSummaryDTO';

import { AnalyticsDTO } from '../../../src_server/entity/dto/AnalyticsDTO';

import { ResultReportDTO } from '../../../src_server/entity/dto/ResultReportDTO';

import { GeneratedBizBase } from '../GeneratedBizBase';

import { Response } from '../../../src_server/response/Response';
export class AdminService extends GeneratedBizBase {
  async getAdminUsers(building_id: string): Promise<Response<AdminDTO[]>> {
    return super.restCall<Response<AdminDTO[]>>('post', '/v1/AdminService/getAdminUsers', arguments);
  }
  async addAdminUsers(building_id: string, user_name: string, mail: string, password: string, user_type: string): Promise<Response<AdminDTO>> {
    return super.restCall<Response<AdminDTO>>('post', '/v1/AdminService/addAdminUsers', arguments);
  }
  async getLessonSummary(building_id: string): Promise<Response<LessonSummaryDTO[]>> {
    return super.restCall<Response<LessonSummaryDTO[]>>('post', '/v1/AdminService/getLessonSummary', arguments);
  }
  async getAnaliticsData(start_dt: Date): Promise<Response<AnalyticsDTO[]>> {
    return super.restCall<Response<AnalyticsDTO[]>>('post', '/v1/AdminService/getAnaliticsData', arguments);
  }
  async completeDelete(user_id: string, building_id: string): Promise<Response<number>> {
    return super.restCall<Response<number>>('post', '/v1/AdminService/completeDelete', arguments);
  }
  async changePassword(user_id: string, newPassword: string): Promise<Response<number>> {
    return super.restCall<Response<number>>('post', '/v1/AdminService/changePassword', arguments);
  }
  async getResultReportList(targetMonth: string, building: string): Promise<Response<ResultReportDTO[]>> {
    return super.restCall<Response<ResultReportDTO[]>>('get', '/v1/AdminService/getResultReportList', arguments);
  }
}
